import { Disclosure } from "@headlessui/react";

interface NavbarContentProps {
  children: React.ReactNode;
}

export const NavbarContent = ({ children }: NavbarContentProps) => {
  return (
    <Disclosure
      as="nav"
      className="flex h-full w-full items-center justify-between sm:min-h-10"
    >
      {children}
    </Disclosure>
  );
};
